// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
/**
 * The CRM Activity Log's type → icon mapping, extracted from ActivityLogPanel.
 * Pure and presentational: a single 16px lucide glyph per activity type, with
 * the generic Activity icon as the fallback for unknown types. Kept verbatim
 * from the panel's former inline `getActivityIcon`.
 */
import type { ReactElement } from "react"
import {
  Activity as ActivityIcon,
  Clock,
  FileText,
  Mail,
  MessageSquare,
  Phone,
  RefreshCw,
  ShoppingCart,
  Target,
  TrendingUp,
  UserPlus,
  Users,
} from "lucide-react"

/** Map an activity `type` to its 16px icon; unknown types get the Activity glyph. */
export function getActivityIcon(type: string): ReactElement {
  switch (type) {
    case "call": return <Phone size={16} />
    case "email": return <Mail size={16} />
    case "meeting": return <Users size={16} />
    case "purchase": return <ShoppingCart size={16} />
    case "login": return <ActivityIcon size={16} />
    case "support": return <MessageSquare size={16} />
    case "note": return <FileText size={16} />
    case "task": return <Target size={16} />
    case "demo": return <Target size={16} />
    case "follow_up": return <Clock size={16} />
    case "deal_renewal": return <RefreshCw size={16} />
    case "renewal_reminder": return <RefreshCw size={16} />
    case "customer_created": return <UserPlus size={16} />
    case "lead_created": return <UserPlus size={16} />
    case "conversion": return <TrendingUp size={16} />
    default: return <ActivityIcon size={16} />
  }
}
